import { ModuleFE_AdvisorConfiguration } from './ModuleFE_AdvisorConfiguration.js';
export const ModulePackFE_AdvisorConfiguration = [ModuleFE_AdvisorConfiguration];
//# sourceMappingURL=module-pack.js.map